import React from "react";
import "../../styles/admin/iqTestQuestionPreview.scss";
import CloseIcon from "@mui/icons-material/Close";
const IqTestQuestionPreview = ({ isOpen, onClose, showPreviewQuestion }) => {
  return (
    <div>
      <div className="iq-question-preview-container">
        <div className="iq-question-preview-info">
          <div className="iq-question-preview-header-container">
            <h2>Preview question</h2>
            <button
              className="iq-question-preview-header-close-button"
              onClick={onClose}
              aria-label="Close"
            >
              <CloseIcon fontSize="small" />
            </button>
          </div>
          <div className="iq-question-preview-question-container">
            {showPreviewQuestion &&
              showPreviewQuestion?.map((d, i) => {
                return (
                  <div className="iq-question-preview-main-container" key={i}>
                    <div className="iq-question-preview-main-info">
                      <label className="iq-question-preview-label">
                        Question {i + 1}
                      </label>
                      <div className="iq-question-preview-question-data">
                        {d?.content?.question || ""}
                      </div>
                      {Object.entries(d?.content?.options)?.map(
                        ([key, value], idx) => (
                          <div
                            className={`iq-question-preview-option-container ${
                              d?.content?.answer === key ? "correct-option" : ""
                            } `}
                            key={idx}
                          >
                            <span className="iq-question-preview-key">
                              {key}.
                            </span>
                            <div className="iq-question-preview-option-data">
                              {value}
                            </div>
                            <span
                              className={`iq-question-preview-answer ${
                                d?.content?.answer === key
                                  ? "correct-indicator"
                                  : ""
                              }`}
                            >
                              ✓
                            </span>
                          </div>
                        )
                      )}

                      <div className="iq-question-preview-hint-container">
                        <label className="iq-question-preview-label">
                          Hint{" "}
                        </label>
                        <div className="iq-question-preview-explanation-data">
                          {d?.hint || ""}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IqTestQuestionPreview;
